<template>
  <div id="main" class="app-main">
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: 'app',
  data () {
      return {
        //shrink: false,
      };
  },
  computed: {
    menuList() {
      //return this.$store.state.app.menuList;
    },
  },
  methods: {
    init () {}
  },
  watch: {

  },
  mounted () {
      this.init();
  },
  created () {

  },
}
</script>


// WEBPACK FOOTER //
// src/views/Main.vue